import {Platform, StyleSheet} from 'react-native';

import {
  cloud,
  cloudLighter,
  grayscale,
  onyx,
  silverChalice,
  white,
} from '/theme/color/on.color';
import {
  codGray,
  cyanBlue,
  denim,
  pearlGreen,
  pineDarker,
  wineRed,
} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  card: {
    backgroundColor: white,
    borderWidth: 1,
    borderColor: cloud,
    borderRadius: 10,
    padding: 12,
    marginHorizontal: 18,
    marginVertical: 6,
    ...(Platform.OS === 'web' && {cursor: 'pointer'}),
  },
  container: {
    gap: 8,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    minHeight: 40,
  },
  userInfo: {
    flex: 1,
    minWidth: 0,
    paddingRight: 10,
    gap: 2,
    alignItems: 'flex-start',
  },
  userName: {
    fontSize: 18,
    fontWeight: '600',
    color: codGray,
    lineHeight: 24,
  },
  userRole: {
    fontSize: 12,
    fontWeight: '600',
    color: silverChalice,
    lineHeight: 18,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
  headerRight: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    alignSelf: 'flex-start',
    flexShrink: 0,
    gap: 8,
  },
  orderType: {
    fontSize: 12,
    fontWeight: '600',
    color: silverChalice,
    lineHeight: 18,
  },
  badge: {
    borderRadius: 6,
    paddingHorizontal: 8,
    height: 22,
    justifyContent: 'center',
    alignItems: 'center',
  },
  badgeOrder: {
    backgroundColor: pearlGreen,
  },
  badgeReturned: {
    backgroundColor: cloudLighter,
  },
  badgeScheduled: {
    backgroundColor: cyanBlue,
  },
  badgeCancelled: {
    backgroundColor: cloudLighter,
  },
  badgeText: {
    fontSize: 12,
    fontWeight: '600',
    lineHeight: 18,
  },
  badgeTextOrder: {
    color: pineDarker,
  },
  badgeTextReturned: {
    color: wineRed,
  },
  badgeTextScheduled: {
    color: denim,
  },
  badgeTextCancelled: {
    color: onyx,
  },
  detailsRow: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    gap: 2,
  },
  dateAndOrderRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 2,
  },
  primaryDateText: {
    flex: 1,
    minWidth: 0,
    paddingRight: 2,
  },
  detailText: {
    fontSize: 14,
    fontWeight: '600',
    color: silverChalice,
    lineHeight: 20,
    flexShrink: 1,
  },
  detailTextScheduledCard: {
    fontSize: 13,
    lineHeight: 16,
  },
  orderNumber: {
    marginLeft: 'auto',
    maxWidth: '35%',
    textAlign: 'right',
    alignSelf: 'flex-end',
    flexShrink: 1,
  },
  orderNumberScheduledCard: {
    maxWidth: '45%',
  },
  statsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginTop: 4,
  },
  statItem: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 4,
  },
  statLabel: {
    fontSize: 12,
    fontWeight: '600',
    color: silverChalice,
    lineHeight: 18,
  },
  subTotalContainer: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 4,
  },
  subTotalLabel: {
    fontSize: 12,
    fontWeight: '600',
    color: silverChalice,
    lineHeight: 18,
    textAlign: 'right',
  },
  statValue: {
    fontSize: 16,
    fontWeight: '600',
    color: codGray,
    lineHeight: 22,
  },
  totalContainer: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 4,
  },
  totalLabel: {
    fontSize: 12,
    fontWeight: '600',
    color: grayscale,
    lineHeight: 18,
    textAlign: 'right',
  },
  totalValue: {
    fontSize: 16,
    fontWeight: '600',
    color: codGray,
    lineHeight: 22,
  },
});
